// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import ReportConstants from 'constants/ReportConstants'

const ReportStore = Marty.createStore({
  id: 'ReportStore',
  getInitialState() {
    return {
      activities: undefined
    }
  },

  handlers: {
    fetchUsersActivityDone: ReportConstants.FETCH_USERS_ACTIVITY_DONE
  },

  fetchUsersActivity() {
    return this.fetch({
      id: 'fetchUsersActivity',
      // gotta make sure the access token work
      dependsOn: [this.app.stores.UserStore.getOrFetchCurrentUser()],
      locally() {
        return this.state.activities
      },
      remotely() {
        return this.app.queries.ReportQueries.fetchUsersActivity()
      }
    })
  },

  fetchUsersActivityDone(activities) {
    return this.setState({ activities })
  }
})

export default ReportStore


// WEBPACK FOOTER //
// ./src/scripts/stores/ReportStore.js